import React from 'react';
import './App.css';
import {AppRouter} from './components/Router/AppRouter';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './utils/appInsights';
import "../src/assets/css/colors.css";
import "../src/assets/css/styles.css";
import "../src/assets/js/main.js"
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; 
import 'bootstrap/dist/css/bootstrap.min.css'; 
import 'primeicons/primeicons.css';
import '../src/assets/css/style.min.css';
import '../src/assets/css/fonts.css';


function App() {
  return (
    <>
    <AppInsightsErrorBoundary onError={() => <h1>Something went wrong!</h1>} appInsights={reactPlugin}>
    <AppRouter />
  </AppInsightsErrorBoundary>,
    </>
  );
}

export default App;
